import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { VersioningService } from '../versioning.service';

@Component({
  selector: 'lohi-versioning',
  templateUrl: './versioning.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersioningComponent implements OnInit {
  @HostBinding('class') public classes = 'version-warning';
  @HostBinding('class.wrong-version') public isWrongVersion = false;
  constructor(
    // Leave this here for the polling
    // @ts-ignore
    private versioningService: VersioningService,
    private swUpdate: SwUpdate,
    private cd: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.swUpdate.available.pipe().subscribe(() => {
      this.isWrongVersion = true;
      this.cd.markForCheck();
    });
  }

  public reload() {
    location.reload();
  }
}
